import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Eye, Calendar } from 'lucide-react';
import { format } from 'date-fns';

interface AssessmentHistoryCardProps {
  submission: {
    id: string;
    completed_at: string;
    profile_name: string | null;
    assessment_type: string;
    scores: any;
  };
  onView: () => void;
  index?: number;
}

const AssessmentHistoryCard: React.FC<AssessmentHistoryCardProps> = ({ submission, onView, index = 0 }) => {
  const completedDate = format(new Date(submission.completed_at), 'MMM d, yyyy');
  
  return (
    <Card 
      className="border-2 border-gray-200 hover-lift-sm press-feedback hover:border-gray-300 cursor-pointer animate-fade-in"
      onClick={onView}
      style={{
        animationDelay: `${index * 50}ms`,
        animationFillMode: 'backwards'
      }}
    >
      <CardContent className="p-10">
        <div className="flex items-center justify-between">
          <div className="flex-1 spacing-2">
            <h3 className="text-heading-m text-black">
              {submission.profile_name || 'Assessment Results'}
            </h3>
            <div className="flex items-center gap-3 text-body-s text-gray-600">
              <Calendar className="h-4 w-4" strokeWidth={2} />
              <span>Completed {completedDate}</span>
              <span>•</span>
              <span className="capitalize">{submission.assessment_type}</span>
            </div>
          </div>
          <Button 
            onClick={(e) => {
              e.stopPropagation();
              onView();
            }} 
            size="lg" 
            className="flex items-center gap-2"
          >
            <Eye className="h-5 w-5" strokeWidth={2} />
            View Results
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default AssessmentHistoryCard;
